import { StatusPill } from '@/components/ui/StatusPill';
import { useI18n } from '@/hooks/useI18n';
import { publications } from '../data';

export const PublicationsTable = () => {
  const { t } = useI18n();

  return (
    <table className="data-table">
      <thead>
        <tr>
          <th scope="col">{t('table.title')}</th>
          <th scope="col">{t('table.journal')}</th>
          <th scope="col">{t('table.indexed')}</th>
          <th scope="col">{t('table.status')}</th>
          <th scope="col">{t('table.year')}</th>
        </tr>
      </thead>
      <tbody>
        {publications.map((publication) => (
          <tr key={publication.id}>
            <td>{publication.title}</td>
            <td>{publication.journal}</td>
            <td>{publication.indexed}</td>
            <td>
              <StatusPill status={publication.status} />
            </td>
            <td>{publication.year}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
